<template>
	<div class="index">
		<div class="title-serch">
			<!--      <span style="white-space: nowrap;margin-left: var(--base-px-10);color:#1890ff">-->
			<!--        团队1111-->
			<!--        <a-icon type="swap"/>-->
			<!--      </span>-->
			<van-search
				style="flex: 1;"
				v-model="serchValue"
				show-action
				placeholder="搜索"
				shape="round"
				@search="onSearch"
				@clear="clearSerch"
			>
				<template #action>
					<div @click="routerPush('/roomMessageBatchSend/create')" style="    display: flex;
    align-items: center; color:#2b60dd;    font-size: var(--base-px-26);">
						<van-icon style="font-size: var(--base-px-26)" name="add"/>
					</div>
				</template>
			</van-search>
		</div>
		<div class="content">
			<div>
			</div>

			<div class="item" v-if="messageList.length > 0">
				<div class="item-body">
					<div>
						<div @click.stop="detailItem(item)" v-for="(item,index) in messageList" :key="index" class="body-item">
							<div style="    width: 69%;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;">
								<span>{{ item.batchTitle }}</span>
								<i style="    font-style: normal;
    background: #1890ff;
    color: #fff;
    font-size: var(--base-px-12);
    padding: var(--base-px-1);
    border-radius: var(--base-px-4);">{{ item.sendStatus != 0 ? '已发送' : '待发送' }}</i>
							</div>
							<div>
								共 {{ item.sendEmployeeTotal }} 名员工需发送，<span
								style="color: orange;">{{ item.notSendTotal }} </span>名员工未发送
							</div>
							<div style="    max-width: var(--base-px-210);
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;">
								{{ item.createdAt }} 由 {{ item.creatorName }} 创建
							</div>
						</div>
					</div>
				</div>
			</div>
			<van-empty
				v-else
				class="custom-image"
				:image="require('../../assets/images/search-no-data.svg')"
				description="暂无数据"
			/>
		</div>
	</div>
</template>

<script>
import {roomMessageBatchSend} from "../../api/roomMessageBatchSend";

export default {
	components: {},
	data() {
		return {
			// 文字
			serchValue: '',
			message: '',
			// tbas切换
			tabsChose: 0,
			// 分组名称
			groupName: '',
			// 数据
			messageList: []
		}
	},
	watch: {},
	created() {
		this.codeData()
	},
	methods: {
		onClickLeft() {
			this.$router.back()
		},
		routerPush(e) {
			this.$router.push(e)
		},
		// 搜索
		onSearch() {
			this.codeData(this.serchValue)
		},
		clearSerch() {
			this.serchValue = ''
			this.codeData()
		},
		//清除
		clear() {
			this.groupName = ''
			this.codeData()
		},
		// 获取数据
		codeData(batchTitle) {
			roomMessageBatchSend({batchTitle}).then(res => {
				this.messageList = res.data.list
			})
			// channelCodeIndex({
			//   groupId: this.groupName.groupId ? this.groupName.groupId : 0,
			//   name
			// }).then(res=>{
			//   this.messageList = res.data
			// })
		},

		// 编辑
		editCode(item) {
			this.$router.push({
				path: "/channelCode/create",
				query: {
					id: item.channelCodeId
				}
			})
		},
		// 詳情
		detailItem(i) {
			this.$router.push({
				path: '/roomMessageBatchSend/details',
				query: {
					id: JSON.stringify(i.id)
				}
			})
		}
	}
}
</script>

<style lang="less" scoped>
/deep/ .van-tabs__line {
	bottom: var(--base-px-9);
	margin-top: 0;
}

/deep/ .van-tabs__nav--line {
	padding-bottom: var(--base-px-1);
}

/deep/ .van-tab__text {
	margin-bottom: var(--base-px-10);
}

/deep/ .van-tab {
	background: #ffffff;
}

/deep/ .van-tabs__nav {
	background: #F1f2f5;
}

/deep/ .van-empty__image img {
	object-fit: contain;
}

.index {
	font-size: var(--base-px-14);
	height: 100%;
	background: #fff;

	p {
		margin: 0 !important;
	}

	.main-agency {
		//width:  var(--base-px-280);
		//overflow: hidden;
		//text-overflow: ellipsis;
		//display: -webkit-box;
		//-webkit-box-orient: vertical;
		//-webkit-line-clamp: 2;
		width: var(--base-px-150);
		/* height: 127px; */
		white-space: pre-wrap;
		overflow: hidden;
		display: -webkit-box;
		-webkit-line-clamp: 2;
		-webkit-box-orient: vertical;
		display: inline-block;
		text-overflow: ellipsis;
	}

	.fs17 {
		font-size: var(--base-px-17);
	}

	.fs14 {
		font-size: .14px;
	}

	.title-serch {
		display: flex;
		align-items: center;
		justify-content: space-between;

	}

	.bets {
		display: flex;
		align-items: center;
		justify-content: space-around;
		max-width: var(--base-px-86);
		/* background: red; */
		height: var(--base-px-25) !important;
		padding: 0 var(--base-px-10);
		border: var(--base-px-1) solid #ccc;
		border-radius: var(--base-px-5);

		span {
			flex: 1;
			white-space: nowrap;
			text-overflow: ellipsis;
			overflow: hidden;
			margin-right: var(--base-px-5);
			display: block;
		}
	}

	.bet {
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.content {
		background: #f4f5f7;
		min-height: 94%;
		//padding-top: var(--base-px-5);
		margin-top:  var(--base-px--15);

		img {
			width: var(--base-px-22);
			height: var(--base-px-22);
		}

		.item {
			padding: var(--base-px-12) var(--base-px-16);
			width: 100%;
			background: #f4f5f7;

			.title {
				width: 100%;
				font-size: var(--base-px-12);

				div:nth-child(1) {
					color: #444;
					font-size: var(--base-px-12);
				}

				img {
					width: var(--base-px-14);
					height: var(--base-px-14);
				}
			}

			.item-body {
				.body-item {
					background: #ffffff;
					padding: var(--base-px-18) var(--base-px-14);
					margin-top: var(--base-px-10);
					border-radius: var(--base-px-12);
					font-size: var(--base-px-12);
					color: #585757;
					position: relative;

					div {
						margin-bottom: var(--base-px-5);
					}

					div:nth-child(1) {
						color: #444;
						margin-bottom: var(--base-px-10);

						span {
							color: #000;
							border-radius: var(--base-px-5);
							font-size: var(--base-px-16);
							margin-right: var(--base-px-9);
						}
					}

					div:last-child {
						margin-top: var(--base-px-10);
						color: #939393;
					}

					.img {
						position: absolute;
						right: var(--base-px-14);
						width: var(--base-px-90);
						height: var(--base-px-90);
						top: 47%;
						margin: 0 !important;
						padding: 0 !important;
						transform: translateY(-50%);

						img:nth-child(1) {
							width: 100%;
							height: 100%;
						}

						img:nth-child(2) {
							position: absolute;
							top: 50%;
							left: 50%;
							transform: translate(-50%, -50%);
						}
					}

					.operation {
						margin-bottom: var(--base-px--9);
						margin-top: var(--base-px-12);
						display: flex;
						align-items: center;
						justify-content: space-between;
					}
				}
			}
		}
	}
}
</style>
